<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Observadores</h3>
        </div>

        <!-- Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Observadores</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList || loadingWatcherType"></loader>
              <table
                class="table mb-0"
                v-if="!loadingList && !loadingWatcherType"
              >
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Nome</th>
                    <th scope="col" class="border-0">Tipo de Observador</th>
                    <th scope="col" class="border-0">Intervalo de execução</th>
                    <th scope="col" class="border-0 text-center">Código</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(watcher, index) in watchers" :key="index">
                    <td></td>
                    <td class="text-left">{{ watcher.Name }}</td>
                    <td>{{ GetWatcherType(watcher.WatcherType.Code).Name }}</td>
                    <td>
                      {{
                        GetWatcherType(watcher.WatcherType.Code).TimeFormatted
                      }}
                    </td>
                    <td class="text-center">{{ watcher.Code }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('Watcher', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenWatcher($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            class="dropdown-item"
                            v-if="
                              !watcher.IsExcluded &&
                              $isAuthorize('Watcher', 'Update')
                            "
                            href="#"
                            v-on:click="OpenWatcher($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            class="dropdown-item"
                            v-if="
                              !watcher.IsExcluded &&
                              $isAuthorize('Watcher', 'Delete')
                            "
                            href="#"
                            v-on:click="
                              ConfirmRemoveWatcher(watcher.Name, watcher.Id)
                            "
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      watchers == undefined ||
                      watchers == null ||
                      watchers.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      :title="modalTitle"
      id="mFormWatcher"
      size="md"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <!-- Name -->
        <ValidationObserver tag="form" ref="WatcherValidationForm">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Nome</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <b-input
                  :class="validatedWatcherForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  type="text"
                  v-model="infoWatcher.Name"
                ></b-input>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedWatcherForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-col md="12">
              <div class="form-group">
                <label>Tipo do Observador</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <d-select
                    v-model="infoWatcher.WatcherType.Code"
                    :class="validatedWatcherForm | showValidateError(invalid)"
                    :disabled="isSeeing"
                  >
                    <option :value="null" selected>Selecione</option>
                    <option
                      v-for="type in watcherTypes"
                      v-bind:value="type.Code"
                      v-bind:key="type.Code"
                      v-if="isSeeing || (!isSeeing && !type.IsExcluded)"
                    >
                      {{ type.Name }}
                    </option>
                  </d-select>
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedWatcherForm"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </div>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveWatcher()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      centered
      id="mFilter"
      title="Filtros"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <input
            class="form-control"
            placeholder="Nome"
            type="text"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>

      <d-form-row>
        <d-col md="12" class="form-group">
          <d-select v-model="filter.IsExcluded" :value="null">
            <option :value="true" selected>Removidos</option>
            <option :value="null" selected>Ativos</option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          @click="Filter()"
          class="btn btn-primary"
          title="Pesquisar"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          @click="ResetFilter()"
          class="input-group-text"
          title="Limpar filtros"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('Watcher', 'Add')"
      class="btn-float success"
      href="#"
      title="Novo observador"
      v-b-tooltip.hover
      v-on:click="OpenWatcher($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";

export default {
  name: "watchers",
  data: function () {
    return {
      countFilter: 0,
      fields: [],
      watchers: [],
      watcherTypes: [],
      filter: {
        Description: null,
        IsExcluded: null,
      },
      idWatcher: 0,
      infoWatcher: {
        Name: null,
        WatcherType: {
          Code: 0,
        },
      },
      isSeeing: false,
      loadingAddUpdate: false,
      loadingList: false,
      loadingModal: false,
      loadingTimers: false,
      loadingWatcherType: false,
      modalTitle: "Novo observador",
      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0,
      },
      selected_field: null,
      validatedWatcherForm: false,
      Watcher: {
        Time: {
          Days: 0,
          Hours: 0,
          Minutes: 0,
        },
      },
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListWatcher();
    },
    "pagination.RowsPerPage": function () {
      this.ListWatcher();
    },
  },
  beforeMount() {
    this.ListWatcher();
  },
  created() {
    this.ListWatcherType();
  },
  mounted() {
    this.ListWatcher();
  },
  methods: {
    GetDDHHmm: function (totalMinutes, format = "object") {
      const decml_days = totalMinutes / 60 / 24;
      const day_has_decimal =
        decml_days.toPrecision().split(".").length > 1 ? true : false;
      var days = parseInt(decml_days.toPrecision().split(".")[0]);
      var hours = 0;
      var minutes = 0;

      if (day_has_decimal) {
        const decml_hours =
          parseFloat("0." + decml_days.toPrecision().split(".")[1]) * 24;
        const hr_has_decimal =
          decml_hours.toPrecision().split(".").length > 1 ? true : false;
        hours = parseInt(decml_hours.toPrecision().split(".")[0]);

        if (hr_has_decimal) {
          const decml_minutes =
            parseFloat("0." + decml_hours.toPrecision().split(".")[1]) * 60;
          minutes = parseInt(decml_minutes.toPrecision().split(".")[0]);
        }
      }
      if (format === "DDHHmm") {
        let retData = "";
        if (days > 0) retData += days + "d ";
        if (hours > 0) retData += hours + "hr ";
        if (minutes > 0) retData += minutes + "min";

        return retData;
      }
      if (format === "object") {
        return {
          days,
          hours,
          minutes,
        };
      }
    },
    GetWatcherType: function (code) {
      let watcherType = this.watcherTypes.find((elm) => elm.Code === code);
      if (watcherType === undefined) watcherType = { Name: "", Time: 0 };
      return {
        Name: watcherType.Name || "",
        Time: watcherType.Time || 0,
        TimeFormatted: this.GetDDHHmm(watcherType.Time, "DDHHmm") || "",
      };
    },
    OpenWatcher: function (e, i, view) {
      e.preventDefault();
      this.validatedWatcherForm = false;
      this.ResetInfoWatcher();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idWatcher = this.watchers[i].Id;
        this.isSeeing = false;
        this.modalTitle = `Editar observador [Code: ${this.watchers[i].Code}]`;
        this.GetWatcher();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Novo observador";
        this.ResetInfoWatcher();
      } else {
        // View
        this.pOpened = i;
        this.idWatcher = this.watchers[i].Id;
        this.isSeeing = true;
        this.modalTitle = `Detalhes do observador [Code: ${this.watchers[i].Code}]`;
        this.GetWatcher();
      }
      this.$bvModal.show("mFormWatcher");
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListWatcher();
    },
    ResetFilter: function () {
      this.filter = {
        Description: null,
        IsExcluded: null,
      };
      this.ListWatcher();
    },
    ResetInfoWatcher: function () {
      this.infoWatcher = {
        Name: null,
        WatcherType: {
          Code: 0,
        },
      };
    },
    SaveWatcher: function () {
      this.validatedWatcherForm = true;
      this.$refs.WatcherValidationForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.$store
              .dispatch("AddWatcher", this.infoWatcher)
              .then(() => {
                this.$makeToast(
                  "O observador foi cadastrado com sucesso.",
                  "success",
                  "Observador cadastrado"
                );
                this.ListWatcher();
                this.$bvModal.hide("mFormWatcher");
              })
              .catch((error) => {
                this.$makeToast(
                  "Tente novamente mais tarde.",
                  "danger",
                  "Erro ao criar observador cadastrado",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateWatcher", this.infoWatcher)
              .then(() => {
                this.$makeToast(
                  "O observador foi atualizado.",
                  "success",
                  "Atualizado"
                );
                this.ListWatcher();
                this.$bvModal.hide("mFormWatcher");
              })
              .catch((error) => {
                this.$makeToast(
                  "Erro ao atualizar o observador, tente novamente.",
                  "danger",
                  "Erro ao modificar observador",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetWatcher: function () {
      if (this.idWatcher != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetWatcher", { id: this.idWatcher })
          .then((response) => {
            this.infoWatcher = response;
          })
          .catch((error) => {
            this.$makeToast(
              "Um erro ocorreu ao carregar o observador",
              "danger",
              "Erro ao carregar o observador",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListWatcher: function () {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.IsExcluded)) this.countFilter++;
      let data = {
        ...this.pagination,
        "Object.IsExcluded": this.filter.IsExcluded,
        "Object.Name": this.filter.Name,
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListWatcher", { params: data })
        .then((response) => {
          this.watchers = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            "Um erro ocorreu ao listar os observadores. Tente novamente.",
            "danger",
            "Erro ao listar os observadores",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ListWatcherType: function () {
      this.loadingWatcherType = true;
      this.$store
        .dispatch("ListWatcherType", {})
        .then((response) => {
          this.watcherTypes = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            "Um erro ocorreu ao listar os tipos de observadores. Tente novamente.",
            "danger",
            "Erro ao listar os tipos de observadores",
            error
          );
        })
        .finally(() => {
          this.loadingWatcherType = false;
        });
    },
    ConfirmRemoveWatcher: function (description, id) {
      this.$makeMsgBox(
        `Deseja remover "${description}" ?`,
        "Confirmar",
        this.DeleteWatcher,
        id
      );
    },
    DeleteWatcher: function (id) {
      this.$store
        .dispatch("DeleteWatcher", { id: id })
        .then(() => {
          this.$makeToast(
            "O observador foi removido com sucesso.",
            "success",
            "Removido com sucesso"
          );
          this.ListWatcher();
          this.$bvModal.hide("mFormWatcher");
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente.",
            "danger",
            "Erro ao remover observador",
            error
          );
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/watchers.vue